import { connect } from 'react-redux';
import { setUrlParam, setUrlParams } from '../actions/URLSearchParamActions';

export const connectURLSearchParams = connect(
  ({ urlParams }) => ({ urlParams }),
  { setUrlParam, setUrlParams }
);
